import React from 'react';
import { Col, Descriptions, Form, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { TextAreaQuill } from '../../../atoms/textarea/TextAreaQuill';
import { MAX_LENGTH_DESCRIPTION } from '../../../../constants/common';
import { TOUR_TRASH_TRANSLATION } from '../../../../constants/define/translation';

interface ProductSectionProps {
  length: number;
  isReachedMax: boolean;
  onHandleKeyChange: () => void;
  onHandleChange: (content: any, delta: any, source: any, editor: any) => void;
  isHandleViewTourTrash: boolean;
  isEditTourTrashActive: boolean;
  beginCheck: boolean;
}

export const ProductSection = (props: ProductSectionProps) => {
  const { t } = useTranslation(TOUR_TRASH_TRANSLATION);
  const {
    length,
    isReachedMax,
    onHandleKeyChange,
    onHandleChange,
    isHandleViewTourTrash,
    isEditTourTrashActive,
    beginCheck,
  } = props;
  return (
    <>
      <Descriptions title={t('tab.detail.form.product.title')} />
      <Form.Item
        name="productName"
        rules={[{ required: true, message: t('tab.detail.form.validate.productNameBlank') }]}
      >
        <Input
          placeholder={t('tab.detail.form.product.namePlaceholder')}
          readOnly={isHandleViewTourTrash}
          disabled={isHandleViewTourTrash}
        />
      </Form.Item>
      <Form.Item
        className="form-description"
        name="productDescription"
        initialValue=""
        validateStatus={isReachedMax || length === 0 ? 'error' : 'success'}
        help={beginCheck && `${length} characters (${MAX_LENGTH_DESCRIPTION} maximum)`}
      >
        <TextAreaQuill
          theme="snow"
          bounds=".quill"
          placeholder={t('tab.detail.form.product.descriptionPlaceholder')}
          onKeyDown={onHandleKeyChange}
          onKeyUp={onHandleKeyChange}
          onChange={onHandleChange}
          readOnly={isHandleViewTourTrash}
        />
      </Form.Item>
      <Form.Item className="form-legal" name="productLegal" initialValue="">
        <TextAreaQuill
          theme="snow"
          bounds=".quill"
          placeholder={t('tab.detail.form.product.legalPlaceholder')}
          onKeyDown={onHandleKeyChange}
          onKeyUp={onHandleKeyChange}
          onChange={onHandleChange}
          readOnly={isHandleViewTourTrash}
        />
      </Form.Item>
      {!isEditTourTrashActive && (
        <>
          <Row>
            <Col span={11}>
              <Form.Item name="productVideoType" initialValue="youtube">
                <Input
                  placeholder={t('tab.detail.form.product.videoTypePlaceholder')}
                  readOnly={isHandleViewTourTrash}
                  disabled={isHandleViewTourTrash}
                />
              </Form.Item>
            </Col>
            <Col span={11} offset={2}>
              <Form.Item name="productVideoId">
                <Input
                  placeholder={t('tab.detail.form.product.videoIdPlaceholder')}
                  readOnly={isHandleViewTourTrash}
                  disabled={isHandleViewTourTrash}
                />
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};
